import { useNavigate } from "react-router-dom";
import {
  Bell,
  ChevronDown,
  CircleHelp,
  LogOut,
  Palette,
  Settings2,
  UserRound,
} from "lucide-react";
import { useState } from "react";
import { useAppStore } from "@/store/appStore";
import { Avatar, Dropdown, DropdownItem, DropdownSep, Modal, Button } from "@/components/ui";

export function ProfileMenu() {
  const user = useAppStore((s) => s.user);
  const logout = useAppStore((s) => s.logout);
  const navigate = useNavigate();
  const [confirmOpen, setConfirmOpen] = useState(false);

  if (!user) return null;

  const go = (path: string) => navigate(path);

  const confirmLogout = async () => {
    setConfirmOpen(false);
    await logout();
    navigate("/login");
  };

  return (
    <>
      <Dropdown
        menuClassName="profile-dropdown"
        trigger={
          <Button variant="ghost" aria-label="User menu" className="navbar__profile">
            <Avatar initials={user.initials} className="navbar__avatar" />
            <span className="navbar__profile-meta">
              <strong>{user.name}</strong>
              <span>{user.role}</span>
            </span>
            <ChevronDown size={14} className="navbar__profile-caret" aria-hidden />
          </Button>
        }
      >
        <div className="profile-dropdown__head">
          <Avatar initials={user.initials} className="profile-dropdown__avatar" />
          <div>
            <strong>{user.name}</strong>
            <span>{user.role === "CEO" ? "Administrator" : user.role}</span>
          </div>
        </div>
        <DropdownSep />
        <DropdownItem onClick={() => go("/profile")}>
          <UserRound size={16} /> My Profile
        </DropdownItem>
        <DropdownItem onClick={() => go("/user-settings")}>
          <Settings2 size={16} /> User Settings
        </DropdownItem>
        <DropdownItem onClick={() => go("/appearance")}>
          <Palette size={16} /> Appearance
        </DropdownItem>
        <DropdownItem onClick={() => go("/notification-preferences")}>
          <Bell size={16} /> Notification Preferences
        </DropdownItem>
        <DropdownItem onClick={() => go("/help")}>
          <CircleHelp size={16} /> Help & Support
        </DropdownItem>
        <DropdownSep />
        <DropdownItem danger onClick={() => setConfirmOpen(true)}>
          <LogOut size={16} /> Logout
        </DropdownItem>
      </Dropdown>

      <Modal open={confirmOpen} title="Log out?" onClose={() => setConfirmOpen(false)}>
        <p className="settings-confirm__copy">
          You will be signed out of Cyberweb OPERA OS on this device.
        </p>
        <div className="settings-confirm__actions">
          <Button variant="ghost" onClick={() => setConfirmOpen(false)}>
            Cancel
          </Button>
          <Button variant="primary" className="btn--danger-solid" onClick={confirmLogout}>
            Log out
          </Button>
        </div>
      </Modal>
    </>
  );
}
